var exports = {
  "nM": "EmojiMoveShortcut.module__row___cW1lV1",
  "Kk": "EmojiMoveShortcut.module__icon___cW1lV1",
  "Pf": "EmojiMoveShortcut.module__label___cW1lV1",
};

module.exports = exports;
